// ISIMarkCertification.jsx
import React from "react";

export default function ISIMarkCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISI Mark Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISI Mark Certification Support for Manufacturers
          </h1>
          <div className="w-20 h-1 bg-red-600 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists manufacturers in obtaining ISI Mark
            Certification, helping them navigate BIS product certification
            schemes and Quality Control Orders for regulated products.[web:412][web:415]
          </p>
          <p className="text-gray-700">
            The service focuses on mapping products to the correct Indian
            Standard, preparing applications, and coordinating factory and
            product assessment activities required for grant of BIS licence.[web:413][web:417]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-red-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3735430/pexels-photo-3735430.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Manufacturing line with products undergoing quality checks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISI Mark Certification
            </h2>
            <p className="text-gray-700 mb-4">
              BIS generally expects clear product, factory, and test
              documentation to establish conformity to the relevant Indian
              Standard and the manufacturer’s capability to control quality.[web:412][web:414][web:416]
            </p>
            <div className="bg-gray-50 border border-red-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Product details, including trade name, model/variant list,
                  applicable Indian Standard (IS) number, and manufacturing
                  process flow chart.[web:413][web:416][web:417]
                </li>
                <li>
                  Factory licence or factory registration documents and plant
                  layout, along with basic business registrations and address
                  proof of the manufacturing premises.[web:413][web:414][web:416]
                </li>
                <li>
                  Test reports from BIS‑recognised laboratories demonstrating
                  product compliance with all specified clauses of the relevant
                  IS standard.[web:412][web:413][web:416]
                </li>
                <li>
                  Details of in‑house testing facilities, quality control
                  procedures, authorised signatory information, and equipment
                  calibration records where applicable.[web:414][web:416]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The objective is to help manufacturers secure and maintain BIS
              licences smoothly while keeping applications consistent with BIS
              procedural expectations.[web:412][web:418]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-red-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  BIS Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on identifying applicable IS codes, understanding QCO
                  obligations, and selecting the correct BIS certification
                  route and scheme.[web:412][web:415][web:418]
                </p>
              </div>

              <div className="border-l-4 border-red-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Application Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in structuring forms, attachments, and test reports so
                  that submissions meet BIS documentation and traceability
                  expectations.[web:413][web:414][web:417]
                </p>
              </div>

              <div className="border-l-4 border-red-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance through factory inspection, query responses, and
                  licence grant or renewal, providing long‑term support for ISI
                  mark compliance.[web:413][web:416][web:419]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-red-600 text-red-700 font-medium hover:bg-red-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
